export function getSpreadText(currentSpread, totalPages) {
  if (currentSpread === 0) {
    return 'Back Cover - Front Cover';
  }
  
  const startPage = (currentSpread - 1) * 2 + 1;
  const endPage = Math.min(currentSpread * 2, totalPages);
  return `Pages ${startPage}-${endPage} of ${totalPages}`;
}